const INQUIRY_FORM_NAMES = {
  callback: "we_will_call_you",
  visit: "request_a_visit",
} as const;

export type InquiryFormType = keyof typeof INQUIRY_FORM_NAMES;

export const getInquiryFormName = (type: InquiryFormType): string => {
  return INQUIRY_FORM_NAMES[type];
};
